// extracted by mini-css-extract-plugin
module.exports = {"DatePicker":"styles_DatePicker__2fImS","placeholder":"styles_placeholder__3bHBp"};